"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectorPostcodeLocation$ = exports.SectorPostcodeLocation$outboundSchema = exports.SectorPostcodeLocation$inboundSchema = void 0;
exports.sectorPostcodeLocationToJSON = sectorPostcodeLocationToJSON;
exports.sectorPostcodeLocationFromJSON = sectorPostcodeLocationFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const sectorpostcodelocationwrapper_js_1 = require("./sectorpostcodelocationwrapper.js");
/** @internal */
exports.SectorPostcodeLocation$inboundSchema = z.object({
    data: sectorpostcodelocationwrapper_js_1.SectorPostcodeLocationWrapper$inboundSchema,
});
/** @internal */
exports.SectorPostcodeLocation$outboundSchema = z.object({
    data: sectorpostcodelocationwrapper_js_1.SectorPostcodeLocationWrapper$outboundSchema,
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var SectorPostcodeLocation$;
(function (SectorPostcodeLocation$) {
    /** @deprecated use `SectorPostcodeLocation$inboundSchema` instead. */
    SectorPostcodeLocation$.inboundSchema = exports.SectorPostcodeLocation$inboundSchema;
    /** @deprecated use `SectorPostcodeLocation$outboundSchema` instead. */
    SectorPostcodeLocation$.outboundSchema = exports.SectorPostcodeLocation$outboundSchema;
})(SectorPostcodeLocation$ || (exports.SectorPostcodeLocation$ = SectorPostcodeLocation$ = {}));
function sectorPostcodeLocationToJSON(sectorPostcodeLocation) {
    return JSON.stringify(exports.SectorPostcodeLocation$outboundSchema.parse(sectorPostcodeLocation));
}
function sectorPostcodeLocationFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.SectorPostcodeLocation$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'SectorPostcodeLocation' from JSON`);
}
//# sourceMappingURL=sectorpostcodelocation.js.map